<template>
  <div>
    <div class="custom-autocomplete">
      <label class="data-label">
        {{ label }}
      </label>
      <autocomplete
        :search="search"
        :placeholder="placeholder"
        :get-result-value="getResultValue"
        :debounce-time="debounceTime"
        :auto-select="true"
        @submit="$emit('submit', $event)"
        class="custom-autocomplete__input"
        :class="{ 'is-invalidated': error }"
        :disabled="disabled"
        ref="autocompleteRef"
        :default-value="value"
        @input="onChangeHandler"
      >
        <template #result="{ result, props }">
          <div
            v-bind="props"
            class="custom-autocomplete__result"
            v-if="displayTextName"
          >
            <div class="custom-autocomplete__result__title cursor-pointer">
              {{ result[displayTextName] }}
            </div>
          </div>
          <div
            v-else
            v-bind="props"
            class="custom-autocomplete__custom-result px-3 py-1"
          >
            <div class="d-flex align-items-center cursor-pointer">
              <div class="flex-flex-grow-1">
                <div class="color-black font-14 font-weight-bold">
                  {{ result.fullName | capitalize }}
                </div>
                <div
                  v-if="result.sub1 || result.sub2"
                  class="text-muted font-14 font-italic"
                >
                  {{ result.sub1 }}
                  {{ result.sub2 != '' ? ' / ' + result.sub2 : '' }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </autocomplete>
      <div
        class="custom-autocomplete__clear cursor-pointer"
        @click="onClearHandler"
        v-if="inputValue && showClear"
      >
        <em class="fas fa-times-circle" />
      </div>
    </div>
    <error
      :class="errorClass"
      v-if="error"
      variant="no-border"
      :message="errorMessage"
    />
  </div>
</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue';
import Error from 'custom-error';
export default {
  name: 'CustomAutoComplete',
  components: {
    Autocomplete,
    Error,
  },
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
    search: {
      type: Function,
      required: true,
    },
    getResultValue: {
      type: Function,
      default: () => {},
    },
    debounceTime: {
      type: Number,
      default: () => 0,
    },
    placeholder: {
      type: String,
      default: () => '',
    },
    displayTextName: {
      type: String,
      default: () => '',
    },
    label: {
      type: String,
      default: () => '',
    },
    showClear: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: String,
      default: '',
    },
    errorClass: {
      type: String,
      default: '',
    },
    customErrorMsg: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    inputValue: null,
  }),
  watch: {
    error: function(newValue) {
      if (this.customErrorMsg == null) this.errorMessage = newValue;
    },
    customErrorMsg: function(newValue) {
      this.errorMessage = newValue;
    },
  },
  methods: {
    onChangeHandler(event) {
      this.inputValue = event.target.value;
      this.$emit('changed', this.inputValue);
    },
    onClearHandler() {
      this.$refs.autocompleteRef.value = null;
      this.inputValue = null;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/_colors.scss';

:deep(ul::-webkit-scrollbar) {
  width: 0.8rem;
  background-color: map-get($colors, 'secondary-9');
}

:deep(ul::-webkit-scrollbar-thumb) {
  border-radius: 10px;
  background-color: map-get($colors, 'secondary-8');
}

.is-invalidated {
  border-radius: 7px;
  border: 1px solid map-get($colors, 'invalid-red') !important;
}

.custom-autocomplete {
  &__input {
    ::v-deep {
      .autocomplete {
        &::before {
          font-family: 'Font Awesome 5 Pro';
          content: '\f002';
          color: map-get($colors, 'orange');
          font-weight: bold;
          position: absolute;
          z-index: 0;
          top: 6px;
          left: 11px;
        }

        input {
          height: 36px;
          width: 100%;
          background: map-get($colors, 'white');
          border: 1px solid #e2e2e2;
          border-radius: 5px;
          padding-left: 38px;
          outline: none;

          &::placeholder {
            color: #182f22 !important;
            font-size: 1rem;
          }
        }

        ul {
          padding: 0rem;
          overflow-y: scroll;
          max-height: 14rem;
          background-color: map-get($colors, 'white');
          list-style-position: inside;
          box-shadow: 0px 3px 6px #00000029;
        }
      }
    }
  }
}
</style>
